import _Anchor from './Anchor';

import './style/index.js';

export type { AnchorProps } from './Anchor';
export type { AnchorItemProps } from './AnchorItem';
export type { AnchorTargetProps } from './AnchorTarget';
export * from './type';

export const Anchor = _Anchor;
export default Anchor;
